document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname.includes("/products/")) {
        let fromCollection = sessionStorage.getItem("lastCollection");
        const referrer = document.referrer;
        if (referrer.startsWith(window.location.origin)) {
            const collectionMatch = referrer.match(/\/collections\/([^/?]+)/);
            if (collectionMatch) {
                fromCollection = collectionMatch[1];
                sessionStorage.setItem("lastCollection", fromCollection);
            } else {
                // If the referrer is not a collection page, clear lastCollection
                sessionStorage.removeItem("lastCollection");
            }
        }
        if (fromCollection) {
            let formattedTitle = fromCollection === "all"
                ? "All Products"
                : fromCollection
                    .replace(/-/g, " ")
                    .replace(/\b\w/g, char => char.toUpperCase());

            const breadcrumbLink = document.querySelector(".breadcrumb__list-collection a");
            if (breadcrumbLink) {
                breadcrumbLink.href = `/collections/${fromCollection}`;
                breadcrumbLink.textContent = formattedTitle;
            }
        }
    }
});
